import { API_ENDPOINTS } from '../config/api';

let _navigate: ((path: string) => void) | null = null;

export const setNavigate = (fn: (path: string) => void): void => {
  _navigate = fn;
};

// JWT is stored in an HttpOnly cookie — JS cannot (and should not) read it.
// The browser sends it automatically with every credentialed request.

export const getAuthHeaders = (): HeadersInit => ({
  'Content-Type': 'application/json',
});

export const getAuthHeadersMultipart = (): HeadersInit => ({});

export const isAuthenticated = (): boolean =>
  localStorage.getItem('user') !== null;

export const getUserData = (): {
  userId: number;
  username: string;
  email: string;
  role: string;
  companyName?: string;
} | null => {
  const raw = localStorage.getItem('user');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearSession = (): void => {
  localStorage.removeItem('user');
};

export const logout = async (): Promise<void> => {
  try {
    await fetch(API_ENDPOINTS.logout, {
      method: 'POST',
      credentials: 'include',
    });
  } catch {
    // Silently ignore network errors — clear session regardless
  }
  clearSession();
  if (_navigate) {
    _navigate('/login');
  } else {
    window.location.href = '/login';
  }
};

export const fetchWithAuth = async (
  url: string,
  options: RequestInit = {}
): Promise<Response> => {
  const response = await fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...(options.headers || {}),
    },
  });

  if (response.status === 401) {
    clearSession();
    if (_navigate) {
      _navigate('/login');
    } else {
      window.location.href = '/login';
    }
    throw new Error('Sesión expirada. Por favor inicia sesión nuevamente.');
  }

  return response;
};
